<style>
	body {
		margin: 0;
		padding: 0;
	}
	:root {
		--web-view-ids: Past_Campaign_View;
	}

	.center
	{
		width:50%;
		height: min-content;
		margin: 0 auto;
	}
	.Action_Wrapper
	{
		height: min-content;
		width: 100%;
		margin: 0 auto;
	}
	.Current_Campaign_View_Class {
		position: relative;
		padding: 1rem;
		box-sizing: border-box;
		background: #E5E5E5;
		background-color: rgba(255,255,255,1);
		overflow: hidden;
		margin: 0;
		--web-view-name: Past Campaign View;
		--web-view-id: Past_Campaign_View;
		--web-enable-deep-linking: true;
	}
	
	.Budget {
		position: relative;
		overflow: hidden;
		text-align: left;
		font-family: Montserrat;
		font-style: normal;
		font-weight: bold;
		font-size: 40px;
		color: rgba(0,0,0,1);
	}
	.Locations {
		position: relative;
		overflow: hidden;
		text-align: left;
		font-family: Montserrat;
		font-style: normal;
		font-weight: bold;
		font-size: 40px;
		color: rgba(0,0,0,1);
	}
	.borderbox {
		/* border-color: rgb(0, 204, 204); */
		margin-bottom: 1rem;
		padding: 0.2rem;
	}
	.bid-on-spots {
		border-width: 2px;
		border-style: solid;
		display: inline-block;
		border-color: green;
		padding: 1rem;
		cursor: pointer;
	}
	.align-right {
		display: flex;
		justify-content: baseline;
	}
</style>
<script>
	import {getToken} from "../js-core/conn/auth/auth-main"
	import AdImg from "../components/shared/img/AdImg.svelte"
	const getCampaignProm = getCampaign()
	async function getCampaign() {
		try {
			const adId = getAdId()
			const res = await BSFetch(`ad-owner/ads/get-campaign/${adId}`, {
				method: "GET",
				headers: {
					authorization: getToken(),
					"Content-Type": "application/json"
				},
				mode: "cors",
				cache: "no-cache"})
			if (res.status === 200) {
				const resBody = await res.json()
				const campInfo = resBody.response.campaignInfo
				if (!campInfo) throw "no return"
                campInfo.potentialTVs = campInfo.potentialTVs || []
				campInfo.displayingTVs = campInfo.displayingTVs || []
				let potentTvsWithInfo = []
				for (var i = 0; i < campInfo.potentialTVs.length; i++) {
					campInfo.potentialTVs[i].businessName = await getHostInfo(campInfo.potentialTVs[i].id)
                    }
				for (var i = 0; i < campInfo.displayingTVs.length; i++) {
					campInfo.displayingTVs[i].businessName = await getHostInfo(campInfo.displayingTVs[i].id)
				}
				return campInfo
			} else {
				throw "There was an error the campaign info"
			}
		} catch (e) {
			console.error(e)
			throw "There was an error loading the proper information"
		}
	}
	async function getHostInfo(hostId) {
		try {
			const res = await BSFetch(`tv-owner/host-info/${hostId}`, {
				method: "GET",
				mode: "cors",
				cache: "default"
			})
			if (res.status === 200) {
				const resBody = await res.json()
				return resBody.response.businessName
			} else {
				throw "There was an error getting your locations' info"
			}
		} catch (e) {
			throw "There was an error getting your locations' info"
		}
	}
</script>
<body>
<div class="Current_Campaign_View_Class">
		{#await getCampaignProm}
			<p>waiting for the promise to resolve...</p>
		{:then campinfo}
			<div class="Action_Wrapper ad">
				<AdImg adId={campinfo.bucketId} height="450"></AdImg>
			</div>
			<div class="Action_Wrapper align-right">
				 <button class="main borderbox bid-on-spots" on:click={() => window.location.href = "#/advertiser/place-bid/" + campinfo._id}>
				 	Bid on TV Spots
				 </button>
			</div>
			<!-- <div class="center">
				<div class="Dates">
					<div class="borderbox">
						<span>Days Left</span><span class="light-text">: X </span><br>
					</div>
				</div>
			</div> -->
		<div class="center">
			<div class="borderbox">
				<div class="Budget">
					<span>Budget Spent: </span><span class="light-text">
						${campinfo.cycleBudget - campinfo.costLeft} out of ${campinfo.cycleBudget} used
					</span>
				</div>
			</div>
		</div>
		<div class="center">
			<div class="borderbox">
				<div class="Locations">
					{#if campinfo.displayingTVs && campinfo.displayingTVs.length > 0}
						<span>Locations: </span>
						<span class="light-text">
						{#each campinfo.displayingTVs as displaying}
							{displaying.businessName},
						{/each}
						</span>
					{:else if (campinfo.potentialTVs.length  || []) === 0}
						<span>Locations: </span>
						<span class="light-text">Looks like this ad is not displaying in any locations, try and place a bid on a Brite Host</span>
					{/if}
				</div>
			</div>
		</div>
		{#if campinfo.potentialTVs && campinfo.potentialTVs.length > 0}
		<div class="center">
			<div class="borderbox">
				<div class="Locations">
					<span>Location Bids: </span>
					<span class="light-text">
						{#each campinfo.potentialTVs || [] as potential}
							{potential.businessName}, 
						{/each}
					</span>
				</div>
			</div>
		</div>
		{/if}
		{:catch error}
			<p>Something went wrong: {error.message}</p>
		{/await}
    
</div>
</body>